// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"5aace455","453":"a492ffeb","809":"973cfc3e"}[chunkId] + ".chunk.js";
};